// src/client/pages/ResetPasswordRequest.jsx
import React, { useState } from 'react';
import api from '../../core/api';

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      await api.post(
        '/api/users/request-reset',
        { email },
        { headers: { 'x-client-key': clientKey } }
      );

      setMessage('📧 Lien envoyé si l’email est connu.');
    } catch (error) {
      console.error('❌ Erreur reset password request :', error.response?.data || error.message);

      if (error.response?.status === 404) {
        setMessage('❌ Aucun utilisateur avec cet email.');
      } else {
        setMessage('❌ Une erreur est survenue.');
      }
    }
  };

  return (
    <div className="auth-container">
      <h2>Réinitialiser mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Votre email"
          required
        />
        <button type="submit">Envoyer le lien</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ResetPasswordRequest;
